

/**
 * @param {*} any
 * @returns {Boolean}
 */
export default Array.isArray;


/** WEBPACK FOOTER **
 ** C:/OpenServer/domains/nerv.recursive-iterator.github.my/src/lang/isArray.js
 **/